/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";
import { AcademicTranscriptPreviewInterface } from "@/ts/interfaces/Reporting/AcademicTranscriptPreviewInterface";
import {
    // downloadAcademicTranscriptThunk,
    fetchAcademicTranscriptGradePreviewThunk,
    generateGradeAcademicTranscriptThunk,
    getGradeLatestAcademicTranscriptThunk
} from "../thunks";

export interface ReportingSubState<T> {
    data: T;
    status: REQUEST_STATUS;
    error: string | null;
}

// ---- Slice state
interface AcademicTranscriptState {
    gradePreview: ReportingSubState<AcademicTranscriptPreviewInterface | null>;
    gradeGenerate: ReportingSubState<any | null>;
    gradeLatest: ReportingSubState<any | null>;
    gradeDownload: ReportingSubState<any | null>;
}

const subInitial = <T>(init: T): ReportingSubState<T> => ({
    data: init,
    status: REQUEST_STATUS.IDLE,
    error: null,
});

const initialState: AcademicTranscriptState = {
    gradePreview: subInitial<AcademicTranscriptPreviewInterface | null>(null),
    gradeGenerate: subInitial<any | null>(null),
    gradeLatest: subInitial<any | null>(null),
    gradeDownload: subInitial<any | null>(null),
};

// =================== SLICE ===================
export const reportingGradeAcademicTranscriptSlice = createSlice({
    name: "reporting/gradeAcademicTranscript",
    initialState,
    reducers: {
        resetAcademicTranscriptState: () => initialState,
        clearPreview(state) {
            state.gradePreview = subInitial<AcademicTranscriptPreviewInterface | null>(null);
        },
        clearGenerate(state) {
            state.gradeGenerate = subInitial<any | null>(null);
        },
        clearLatest(state) {
            state.gradeLatest = subInitial<any | null>(null);
        },
        clearDownload(state) {
            state.gradeDownload = subInitial<any | null>(null);
        },
    },
    extraReducers: builder => {
        // preview
        builder
            .addCase(fetchAcademicTranscriptGradePreviewThunk.pending, state => {
                state.gradePreview.status = REQUEST_STATUS.PENDING;
                state.gradePreview.error = null;
            })
            .addCase(fetchAcademicTranscriptGradePreviewThunk.fulfilled, (state, action) => {
                state.gradePreview.status = REQUEST_STATUS.SUCCESS;
                state.gradePreview.data = action.payload.data;
                console.log(action.payload.data);
            })
            .addCase(fetchAcademicTranscriptGradePreviewThunk.rejected, (state, action) => {
                state.gradePreview.status = REQUEST_STATUS.ERROR;
                state.gradePreview.error = action.payload ?? "Preview failed";
            });

        // generate
        builder
            .addCase(generateGradeAcademicTranscriptThunk.pending, state => {
                state.gradeGenerate.status = REQUEST_STATUS.PENDING;
                state.gradeGenerate.error = null;
            })
            .addCase(generateGradeAcademicTranscriptThunk.fulfilled, (state, action) => {
                state.gradeGenerate.status = REQUEST_STATUS.SUCCESS;
                state.gradeGenerate.data = action.payload.data;
            })
            .addCase(generateGradeAcademicTranscriptThunk.rejected, (state, action) => {
                state.gradeGenerate.status = REQUEST_STATUS.ERROR;
                state.gradeGenerate.error = action.payload ?? "Generate failed";
            });

        // latest
        builder
            .addCase(getGradeLatestAcademicTranscriptThunk.pending, state => {
                state.gradeLatest.status = REQUEST_STATUS.PENDING;
                state.gradeLatest.error = null;
            })
            .addCase(getGradeLatestAcademicTranscriptThunk.fulfilled, (state, action) => {
                state.gradeLatest.status = REQUEST_STATUS.SUCCESS;
                state.gradeLatest.data = action.payload.data;
            })
            .addCase(getGradeLatestAcademicTranscriptThunk.rejected, (state, action) => {
                state.gradeLatest.status = REQUEST_STATUS.ERROR;
                state.gradeLatest.error = action.payload ?? "Latest fetch failed";
            });

        // download
        // builder
        //   .addCase(downloadAcademicTranscriptThunk.pending, state => {
        //     state.download.status = REQUEST_STATUS.PENDING;
        //     state.download.error = null;
        //   })
        //   .addCase(downloadAcademicTranscriptThunk.fulfilled, (state, action) => {
        //     state.download.status = REQUEST_STATUS.SUCCESS;
        //     state.download.data = action.payload.data;
        //   })
        //   .addCase(downloadAcademicTranscriptThunk.rejected, (state, action) => {
        //     state.download.status = REQUEST_STATUS.ERROR;
        //     state.download.error = action.payload ?? "Download failed";
        //   });
    },
});

export const {
    resetAcademicTranscriptState,
    clearPreview,
    clearGenerate,
    clearLatest,
    clearDownload,
} = reportingGradeAcademicTranscriptSlice.actions;

export default reportingGradeAcademicTranscriptSlice.reducer;
